import { render, staticRenderFns } from "./edit-widget-settings.vue?vue&type=template&id=80c873c4&scoped=true&"
import script from "./edit-widget-settings.vue?vue&type=script&lang=js&"
export * from "./edit-widget-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c873c4",
  null
  
)

export default component.exports